import { useEffect, useState } from 'react';
import { breakpoints } from '../../config/media';
const useMediaQuery = () => {
    const [currentMedia, setCurrentMedia] = useState('');
    useEffect(() => {
        const mqls = [
            window.matchMedia(`(max-width: ${breakpoints.xl})`),
            window.matchMedia(`(max-width: ${breakpoints.lg})`),
            window.matchMedia(`(max-width: ${breakpoints.md})`),
            window.matchMedia(`(max-width: ${breakpoints.sm})`)
        ];
        function mediaqueryresponse() {
            if (mqls[0].matches) {
                setCurrentMedia('xl');
            }
            if (mqls[1].matches) {
                setCurrentMedia('lg');
            }
            if (mqls[2].matches) {
                setCurrentMedia('md');
            }
            if (mqls[3].matches) {
                setCurrentMedia('sm');
            }
        }
        for (let i = 0; i < mqls.length; i++) {
            mediaqueryresponse();
            mqls[i].addEventListener('change', mediaqueryresponse);
        }
    }, []);
    useEffect(() => {
        for (const breakpoint in breakpoints) {
            const mqlUp = window.matchMedia(`(max-width: ${breakpoints[breakpoint]})`);
            mqlUp.addEventListener('change', (event) => {
                if (event.matches) {
                    setCurrentMedia(breakpoint);
                }
            });
        }
    }, []);
    const mediaDownFrom = (breakpoint) => {
        const mqlUp = window.matchMedia(`(max-width: ${breakpoints[breakpoint]})`).matches;
        return mqlUp;
    };
    const mediaUpFrom = (breakpoint) => {
        const mqlUp = window.matchMedia(`(min-width: ${breakpoints[breakpoint]})`).matches;
        return mqlUp;
    };
    return { currentMedia, mediaDownFrom, mediaUpFrom };
};
export default useMediaQuery;
